/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreatePingResponse, DeviceRegistration, DeviceRegistrationRequest } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Device<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name PingResponseCreate
   * @request POST:/device/ping-response
   */
  pingResponseCreate = (data: CreatePingResponse, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/device/ping-response`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name RegistrationCreate
   * @request POST:/device/registration
   */
  registrationCreate = (data: DeviceRegistrationRequest, params: RequestParams = {}) =>
    this.request<DeviceRegistration, any>({
      path: `/device/registration`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
